import { ChangeEvent, ReactNode, SetStateAction } from 'react';
import styles from '../../styles.module.scss';
import { Fade, TextField } from '@mui/material';
import { inputsSetting } from 'utilities';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { TDefaultListValue } from 'api/http-client/types';
import { createStateInputList, removeStateInputListById, updateStateByValueInputList } from '../../utils';

type Props = {
  title: string;
  items: TDefaultListValue[];
  onSetState: (value: SetStateAction<TDefaultListValue[]>) => void;
  placeholder?: string;
}

export const ArrayInput: React.FC<Props> = ({
  title,
  items,
  onSetState,
  placeholder = "Enter information here"
}) => {
  const addValueToList = () => {
    onSetState((state) => createStateInputList(state));
  };

  const removeValueFromList = (index: number) => {
    onSetState((state) => removeStateInputListById(state, index));
  };

  const setValueToList = (
    id: string | undefined,
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if (!id) return;

    onSetState((state) => {
      return updateStateByValueInputList(state, e.target.value, id);
    });
  };

  return (
    <div className={styles.details__input_wrapper}>
      <p className={styles.details__input_title}>{title}</p>
      <div className={styles.details__input}>
        {items.map((item, index) => {
          return (
            <Fade 
              in={!!item.id} 
              timeout={1000} 
              key={index}
            >
              <div className={styles.details__inputWrap}>
                <div className="inputWithTitle">
                  <TextField
                    value={item.value || ''}
                    className="customInput"
                    variant="outlined"
                    placeholder={placeholder}
                    required
                    sx={inputsSetting.sxWidth}
                    onChange={(e) => setValueToList(item.id, e)}
                  />
                </div>

                {index === 0 ? (
                  <div
                    className={styles.details__inputSvg}
                    onClick={() => addValueToList()}
                  >
                    <AddIcon />
                  </div>
                ) : (
                  <div
                    className={styles.details__inputSvg}
                    onClick={() => removeValueFromList(index)}
                  >
                    <DeleteOutlineOutlinedIcon />
                  </div>
                )}
              </div>
            </Fade>
          );
        })}
      </div>
    </div>
  );
}
